var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextright = function SvgNextright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.912 10.216a.562.562 0 0 0 .095.799l1.77 1.376 2.326 2.043H6.578a.573.573 0 0 0-.578.568c0 .314.258.568.578.568h14.38l-4.035 3.432a.562.562 0 0 0-.06.801.584.584 0 0 0 .815.058l5.265-4.476a.565.565 0 0 0 .2-.425v-.005a.563.563 0 0 0-.193-.424l-3.43-3.01-1.797-1.398a.584.584 0 0 0-.811.093Z"
  })));
};
export default SvgNextright;